
import { CompanyModule } from "@/models/company-module";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { CompanyService } from "@/services/company-service";
import { Company } from "@/models/company";
import { ApiAccessMetaData } from "@/models/module-api-access-meta-data";

export default FormLike.extend({
	data() {
		return {
			maxApiCalls: 0,
			apiCallsUsed: 0,
		};
	},
	props: {
		value: {
			type: Object as () => CompanyModule,
			required: true,
		},
		company: {
			type: Object as () => Company,
			required: true,
		},
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				this.maxApiCalls = ApiAccessMetaData.create(
					this.value.metaData
				).getMaxApiCalls();
				this.apiCallsUsed = ApiAccessMetaData.create(
					this.value.metaData
				).getApiCallsUsed();
			},
		},
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		async submit() {
			if (!this.isValid) return;
			ApiAccessMetaData.create(this.value.metaData).setMaxApiCalls(
				this.maxApiCalls
			);
			ApiAccessMetaData.create(this.value.metaData).setApiCallsUsed(
				this.apiCallsUsed
			);
			await CompanyService.updateModuleOfCompany(
				this.company,
				this.value.id,
				this.value.metaData
			);
			this.$emit("saved", this.value);
			this.$emit("close");
		},
	},
});
